import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { SMITHY_CONTEXT_KEY } from "@smithy/types";
import { getSmithyContext } from "@smithy/util-middleware";
function convertHttpAuthSchemesToMap(httpAuthSchemes) {
  var map = new Map();
  var _iterator = _createForOfIteratorHelper(httpAuthSchemes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var scheme = _step.value;
      map.set(scheme.schemeId, scheme);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return map;
}
export var httpAuthSchemeMiddleware = function httpAuthSchemeMiddleware(config, mwOptions) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var options, authSchemes, smithyContext, failureReasons, _iterator2, _step2, _option$propertiesExt, _option, option, scheme, identityProvider, _ref2, _ref2$identityPropert, identityProperties, _ref2$signingProperti, signingProperties;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = config;
                _context.next = 3;
                return mwOptions.httpAuthSchemeParametersProvider(config, context, args.input);
              case 3:
                _context.t1 = _context.sent;
                options = _context.t0.httpAuthSchemeProvider.call(_context.t0, _context.t1);
                authSchemes = convertHttpAuthSchemesToMap(config.httpAuthSchemes);
                smithyContext = getSmithyContext(context);
                failureReasons = [];
                _iterator2 = _createForOfIteratorHelper(options);
                _context.prev = 9;
                _iterator2.s();
              case 11:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 37;
                  break;
                }
                option = _step2.value;
                scheme = authSchemes.get(option.schemeId);
                if (scheme) {
                  _context.next = 17;
                  break;
                }
                failureReasons.push("HttpAuthScheme `".concat(option.schemeId, "` was not enabled for this service."));
                return _context.abrupt("continue", 35);
              case 17:
                _context.t2 = scheme;
                _context.next = 20;
                return mwOptions.identityProviderConfigProvider(config);
              case 20:
                _context.t3 = _context.sent;
                identityProvider = _context.t2.identityProvider.call(_context.t2, _context.t3);
                if (identityProvider) {
                  _context.next = 25;
                  break;
                }
                failureReasons.push("HttpAuthScheme `".concat(option.schemeId, "` did not have an IdentityProvider configured."));
                return _context.abrupt("continue", 35);
              case 25:
                _ref2 = ((_option$propertiesExt = (_option = option).propertiesExtractor) === null || _option$propertiesExt === void 0 ? void 0 : _option$propertiesExt.call(_option, config, context)) || {}, _ref2$identityPropert = _ref2.identityProperties, identityProperties = _ref2$identityPropert === void 0 ? {} : _ref2$identityPropert, _ref2$signingProperti = _ref2.signingProperties, signingProperties = _ref2$signingProperti === void 0 ? {} : _ref2$signingProperti;
                option.identityProperties = Object.assign(option.identityProperties || {}, identityProperties);
                option.signingProperties = Object.assign(option.signingProperties || {}, signingProperties);
                _context.t4 = option;
                _context.next = 31;
                return identityProvider(option.identityProperties);
              case 31:
                _context.t5 = _context.sent;
                _context.t6 = scheme.signer;
                smithyContext.selectedHttpAuthScheme = {
                  httpAuthOption: _context.t4,
                  identity: _context.t5,
                  signer: _context.t6
                };
                return _context.abrupt("break", 37);
              case 35:
                _context.next = 11;
                break;
              case 37:
                _context.next = 42;
                break;
              case 39:
                _context.prev = 39;
                _context.t7 = _context["catch"](9);
                _iterator2.e(_context.t7);
              case 42:
                _context.prev = 42;
                _iterator2.f();
                return _context.finish(42);
              case 45:
                if (smithyContext.selectedHttpAuthScheme) {
                  _context.next = 47;
                  break;
                }
                throw new Error(failureReasons.join("\n"));
              case 47:
                return _context.abrupt("return", next(args));
              case 48:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 39, 42, 45]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};